'use client'

import * as React from 'react'
import { sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'

const NOT_FOUND_PAGE_LOADED = 'Loaded 404 Page'

export function ClientSide404() {
  React.useEffect(() => {
    replaceWithOriginal404Url()
    sendAmplitudeEvent(NOT_FOUND_PAGE_LOADED)
  }, [])

  return null
}

// This is a workaround to redirect to the web 404 page from other apps
function replaceWithOriginal404Url() {
  const url = new URL(window.location.href)
  const original404Url = url.searchParams.get('original404Url')

  if (original404Url) {
    window.history.replaceState(null, '', original404Url)
  }
}
